import {
  AfterViewInit,
  ComponentRef,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { GasDynamicComponentsService } from '@cikrf/gas-utils/services';
import { GasTable } from '../gas-table.namespace';
import { GasTableService } from '../gas-table.service';
import { GasTableSortingComponent } from './gas-table-sorting.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
  //eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'th[gasSortingtableHeadRow]',
})
export class GasSortingtableHeadRowDirective implements AfterViewInit, OnDestroy {
  @HostBinding('class._active')
  public get activeSorting(): boolean {
    return this.isActive;
  }

  @Input()
  public name = '';

  @Input()
  public key = '';

  private isActive = false;
  private gasTableSortingComponent: ComponentRef<GasTableSortingComponent>;
  private sortTableBind = this.sortTable.bind(this);

  constructor(
    private elementRef: ElementRef,
    private viewContainerRef: ViewContainerRef,
    private gasTableService: GasTableService,
    private renderer: Renderer2,
    private gasDynamicComponentsService: GasDynamicComponentsService,
  ) {

    this.elementRef.nativeElement.addEventListener('click', this.sortTableBind);
    this.renderer.addClass(this.elementRef.nativeElement, 'g-cursor-p');
    this.renderer.addClass(this.elementRef.nativeElement, '_sorting');
  }

  public ngAfterViewInit(): void {
    this.gasTableSortingComponent = this.gasDynamicComponentsService
      .createChildComponent(GasTableSortingComponent, this.viewContainerRef);

    this.gasTableSortingComponent.instance.key = this.key;

    this.gasTableService.selectionTableRepositorySource$.pipe(
      untilDestroyed(this),
    ).subscribe(
      (sorting: GasTable.SortingValue) => {
        if (!sorting) {
          return;
        }
        this.setElementClass(sorting, Object.keys(sorting).includes(this.key));
      },
    );
  }

  public sortTable(): void {
    const sortingData: GasTable.SortingValue = {};
    this.gasTableSortingComponent.instance.isDesc = !this.gasTableSortingComponent.instance.isDesc;
    sortingData[this.key] = this.gasTableSortingComponent.instance.isDesc ? GasTable.TableSorting.Desc : GasTable.TableSorting.Asc;

    this.setElementClass(sortingData, true);

    this.gasTableService.changeSortingSubject.next(sortingData);
  }

  public setElementClass(sorting: GasTable.SortingValue = {}, isActive: boolean = false): void {
    const sortingKey = Object.keys(sorting)[0];
    const sortingValue = Object.values(sorting)[0];

    const element = this.gasTableSortingComponent.instance.key === sortingKey ? this.gasTableSortingComponent.instance : null;

    if (element) {
      element.isDesc = sortingValue ? sortingValue === GasTable.TableSorting.Desc : !element.isDesc;
      this.isActive = isActive;

      this.renderClassName(element, element.isDesc, '_desc');
      this.renderClassName(element, isActive, '_active');
    }
  }

  public ngOnDestroy(): void {
    this.elementRef.nativeElement.removeEventListener('click', this.sortTableBind);
    this.gasDynamicComponentsService.deleteComponent(this.gasTableSortingComponent);
  }

  /**
   *
   * @param element Target
   * @param condition addClass (true) or removeClass (false) className to target nativeElement
   * @param className
   * @private
   */
  private renderClassName(element: GasTableSortingComponent, condition: boolean = false, className: string): void {
    const action = condition ? this.renderer.addClass : this.renderer.removeClass;
    action.call(this.renderer, element.el.nativeElement, className);
  }
}
